import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import './CheckmarkIcon.scss';

const CheckmarkIcon = ({ small, opaque, modifierClass }) => (
	<span
		className={classNames({
			'checkmark-icon': true,
			'checkmark-icon--opaque': opaque,
			'checkmark-icon--small': small,
			[modifierClass]: !!modifierClass,
		})}
	/>
);

CheckmarkIcon.propTypes = {
	opaque: PropTypes.bool,
	small: PropTypes.bool,
};

export default CheckmarkIcon;
